<template>
  <div class="role-list">
    <div class="role-list-title">
      <!-- 头部搜索查找 -->
      <div class="left"></div>
      <div class="right">
        <el-button type="primary" icon="el-icon-plus" @click="handleAddUser('add')">添加角色</el-button>
      </div>
    </div>
    <div class="user-list-table">
      <el-table :data="tableData" style="width: 100%;">
        <el-table-column prop="id" label="序号" width="180">
        </el-table-column>
        <el-table-column prop="name" label="角色名称">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间">
        </el-table-column>
        <el-table-column prop="desc" label="描述">
        </el-table-column>
        <el-table-column label="操作">
          <template scope="scope">
            <div class="handle">
              <span @click="handleInfo(scope.row)"> 角色详情 </span>
              <span class="update" @click="handleUpdata(scope.row)"> 编辑 </span>
              <i class="el-icon-delete" @click="handleDelete(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" :page-sizes="[10, 20, 30, 50, 100]" :current-page="init.page"
        :page-size="init.pageSize" :total="init.total" @prev-click="prevPage" @next-click="nextPage"
        layout="total, prev, pager, next" @current-change="handleCurrentChange" />
    </div>
    <add-dialog v-if="options&&addVisible" :options="options" :addVisible="addVisible" @addConfirm="addConfirm"
      @addCancel="() => addVisible = false"></add-dialog>
    <delete-dialog v-if="dialogVisible" :dialogVisible="dialogVisible" :text="isText" @deleteConfirm="deleteConfirm"
      @deleteCancel="() => dialogVisible = false">
    </delete-dialog>
    <roul-info v-if="info" :visible="visible" :item="info" @infoConfirm="infoConfirm"></roul-info>

    <updata-dialog v-if="updataVisible" :updataVisible="updataVisible" :item="updataItem" :options="options"
      @updataConfirm="updataConfirm" @updataCancel="() => updataVisible = false"></updata-dialog>
  </div>
</template>

<script>
import { getRoulList, getAddRoul, getDeleteRoul, getUpdataRoul, getInfoRoul, getMenuList } from "@/api/roulAdmin";
import AddDialog from "../components/AddRoulDialog.vue";
import DeleteDialog from "@/components/DeleteDialog.vue";
import RoulInfo from "../components/RoulInfo";
import UpdataDialog from "../components/UpdataRoulDialog.vue";
export default {
  data () {
    return {
      tableData: [{
        createTime: "2022-10-16 18:47:31",
        desc: "运营人员专用3",
        id: 4,
        name: "运营人员3",
        remark: "",
        status: 1,
        updateTime: "2022-10-16 18:47:31"
      },
      {
        createTime: "2022-10-16 17:48:54",
        desc: "运营人员专用2",
        id: 3,
        name: "运营人员2",
        remark: "",
        status: 1,
        updateTime: "2022-10-16 18:53:55"
      },
      {
        createTime: "2022-05-13 11:05:31",
        desc: "普通管理员",
        id: 2,
        name: "管理员",
        remark: "",
        status: 1,
        updateTime: "2022-10-08 13:29:06"
      },
      {
        createTime: "2022-05-13 11:05:09",
        desc: "超级管理员具有所有权限",
        id: 1,
        name: "超级管理员",
        remark: "",
        status: 1,
        updateTime: "2022-05-13 11:05:38"
      }],
      init: {
        page: 1,
        pageSize: 20,
        total: 0,
        totalPage: 0
      },
      addVisible: false,
      options: null,
      dialogVisible: false,
      isText: '确定删除该角色?',
      isDelete: null,
      visible: false,
      info: null,
      updataVisible: false,
      updataItem: null
    }
  },
  components: {
    AddDialog,
    DeleteDialog,
    RoulInfo,
    UpdataDialog
  },
  methods: {
    // 分页 =>start
    prevPage () {
      this.init.page > 1 ? this.init.page-- : this.init.page = 1
    },
    nextPage () {
      if (this.init.page < this.init.totalPage)
      {
        this.init.page++
      } else
      {
        this.init.page = this.init.totalPage
      }
    },
    handleCurrentChange (val) {
      this.init.page = val;
      this.gitList()
    },
    // 分页 =>end
    gitList () {
      const { page, pageSize } = this.init;
      getRoulList({ page, pageSize }).then(res => {
        if (res.code === "0")
        {
          if (res.data){
            const { dataList, total, totalPage } = res.data;
            this.tableData = dataList;
            this.init.total = total;
            this.init.totalPage = totalPage
          }
        }
      })
    },
    // 新增角色
    handleAddUser (type) {
      getMenuList().then(res => {
        if (res.code === '0'){
          if (res.data){
            this.options = res.data
            console.log(this.options, "22222222222222222222222333333333333")
            if (type === 'add')
            {
              this.addVisible = true;
            } else
            {
              this.updataVisible = true
            }
          }
        }
      })
    },
    // 确定添加角色
    addConfirm (val) {
      getAddRoul(val).then(res => {
        if (res.code === '0')
        {
          this.options = null;
          this.addVisible = false;
          this.$message({
            message: "添加成功",
            type: 'success'
          });
          this.gitList()
        }
      })
    },
    // 确定删除
    deleteConfirm () {
      // 请求删除接口
      getDeleteRoul(this.isDelete.id).then(res => {
        if (res.code === '0')
        {
          this.$message({
            message: "删除成功",
            type: 'success'
          });
          this.dialogVisible = false;
          this.isDelete = null;
          this.gitList()
        }
      })
    },
    // 删除角色
    handleDelete (row) {
      this.isDelete = row
      this.dialogVisible = true;
    },
    // 角色详情
    handleInfo (row) {
      // 请求详情接口
      getInfoRoul(row.id).then(res => {
        if (res.code === '0' && res.data)
        {
          this.info = res.data;
          this.visible = true
        }
      })
    },
    infoConfirm () {
      this.visible = false;
      this.info = null
    },

    handleUpdata (row) {
      // 编辑角色
      this.handleAddUser('updata');
      this.updataItem = row
    },
    updataConfirm (val) {
      getUpdataRoul(val).then(res => {
        if(res.code === '0'){
          this.gitList()
          this.updataItem = null;
          this.updataVisible = false;
          this.$message({
            message: "修改成功",
            type: 'success'
          });
        }
      })
    }

  },
  mounted () {
    this.gitList()
  }
}
</script>

<style lang="scss" scoped>
.role-list {
  width: 100%;
  height: 100%;
  &-title {
    min-height: 50px;
    max-height: 100px;
    background: #fff;

    .left {
      float: left;
    }

    .right {
      float: right;
    }
  }

  /deep/ .el-table__row {
    .handle {
      .update {
        margin: 0 20px;
      }

      .el-switch,
      .update,
      span,
      .el-icon-delete {
        cursor: pointer;
      }
    }
  }

  /deep/ .pagination {
    width: 100%;
    background: #fff;
    position: absolute;
    right: 0;
    bottom: -25px;
  }
}
</style>